export default __webpack_public_path__ + "static/logo-cern-ae122c83dbc9f35caf9f322f0f624153.png";